import React from 'react'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from '../../../../images/circle-info-regular-full.svg'

function Name ({ localName, setLocalName, isQueryLoading }) {
  const handleNameChange = event => {
    setLocalName(event.target.value)
  }

  return (
    <div className={styles.nameContainerPeople}>
      <div className={styles.inlineLabel}>
        <label className={styles.namePeopleLabel} htmlFor='Name'>
          Name
        </label>
        <Tooltip
          title='Filter by the person’s given name.'
          arrow
          placement='top'
          slotProps={{
            popper: {
              sx: {
                '& .MuiTooltip-tooltip': {
                  maxWidth: 500,
                  fontSize: '13px',
                  padding: '8px'
                }
              }
            }
          }}
        >
          <img
            src={infoIcon}
            alt='First name help'
            width={14}
            height={14}
            className={styles.infoIcon}
            tabIndex={0}
          />
        </Tooltip>
      </div>

      <input
        className={styles.nameInputPeople}
        disabled={isQueryLoading}
        placeholder='Text'
        onChange={handleNameChange}
        value={localName}
        type='text'
      />
    </div>
  )
}

export default Name
